<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Navbar from './Navbar'
	import AddProducts from './AddProducts'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'navbar': Navbar,
			'add-products': AddProducts,
		},
		data () {
			return {
				data: null,
			}
		},
		created () {
			this.init()
		},
		watch: {
			'$route': function () {
				this.data = null
				this.getData()
			},
		},
		methods: {
			init() {
				this.getData()
			},
			reload() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/management/delivery/notes/' + this.$route.params.id + '/edit')
				.then(response => {
					this.data = response.body
				}).catch(function(response) {
					console.log(response)
					if(response.status == 409) {
						this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/deliverynotes/' + this.$route.params.id)
					}
				})
			},
			destroy(product) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/management/delivery/notes/' + that.data.id + '/detach/product/' + product.id)
							.then(response => {
								that.reload()
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			update(data) {
				this.$http.put('admin/management/delivery/notes/' + this.data.id, data)
				.then(response => {
					this.reload()
					this.loading = false
				}).catch(function(response) {
					console.log(response)
				})
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/deliveryNotes/views/Edit.vue